const password_rejected = {
    too_short: 'Use at least {{min}} characters.',
    too_long: 'Use {{max}} characters or fewer.',
    character_types: 'Use at least {{min}} of these: uppercase letters, lowercase letters, numbers, and symbols.',
    unsupported_characters: 'Use only letters, numbers, and standard symbols.',
    pwned: 'This password is too common. Choose one that’s harder to guess.',
    restricted_found: 'Avoid overusing {{list, list}}.',
    restricted: {
        repetition: 'repeated characters',
        sequence: 'sequential characters',
        user_info: 'your personal information',
        words: 'the product name',
    },
};
export default Object.freeze(password_rejected);
